export default __webpack_public_path__ + "static/media/lock.ea725b76.svg";